
import { DateTimeField } from "@/src/components";
import { Datagrid, List, NumberField, Pagination, ReferenceField, TextField } from "react-admin"

const ClaimedDayPagination = () => <Pagination rowsPerPageOptions={[25, 50, 100]} />;

export const ClaimedDayList = () => {
    return (
        <List
            perPage={25}
            pagination={<ClaimedDayPagination />}
            sort={{ field: 'createdAt', order: 'DESC' }}
            exporter={false}
        >
            <Datagrid
                rowClick="edit"
                bulkActionButtons={false}
            >
                {/* <TextField source="id" /> */}
                <ReferenceField label="User" source="user" reference="user">
                    <TextField source="profile.nickname" />
                </ReferenceField>
                <NumberField source="credited" />
                <DateTimeField source="timestamp" />
                <NumberField source="index" />
                <DateTimeField source="createdAt" />
                {/* <DateTimeField source="updatedAt" /> */}



                {/* <TextField source="user" /> */}
            </Datagrid>
        </List>
    )
}